import { useState } from "react";
import { SortConfig } from "../components/common/pagination";

/**
 * Shared sort state for list pages that use the TablePagination component.
 * Keeps the lowercase asc/desc that the API expects while exposing the
 * Asc/Desc SortConfig the component wants — the conversion lives in one place.
 */
export const useSortState = () => {
  const [sortField, setSortField] = useState<string>("");
  const [sortDirection, setSortDirection] = useState<string>("asc");

  const currentSort: SortConfig = {
    sortField,
    sortDirection: sortDirection === "asc" ? "Asc" : "Desc",
  };

  const applySort = (sort: SortConfig) => {
    setSortField(sort.sortField || "");
    setSortDirection(sort.sortDirection === "Asc" ? "asc" : "desc");
  };

  return { sortField, sortDirection, currentSort, applySort };
};
